"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@bluebase/core");
const MaterialIcons_ttf_1 = tslib_1.__importDefault(require("../../Fonts/MaterialIcons.ttf"));
const Icon_1 = require("./Icon");
exports.default = core_1.createPlugin({
    description: 'A BlueBase port of the React Native Vector Icons project',
    key: 'vector-icons-material-icons',
    name: 'Vector Icons - Material Icons',
    version: '1.0.0',
    components: { Icon: Icon_1.Icon },
    fonts: {
        // Native
        'Material Icons': MaterialIcons_ttf_1.default,
        // Web
        MaterialIcons: MaterialIcons_ttf_1.default,
    },
});
